/**
 * 行情页面分类
 */

export enum PageType{
  "沪深A股",
  "英股",
  "美股",
  "日本",
  "韩国",
  "台湾",
  "法国",
  "德国",
  "马来西亚",
  "外汇",
  "全球指数",
  "板块",
  "沪深京指数",
  "choice指数",
  "国证指数",
  "人民币中间价",
  "债券",
  "港股",
  "期货",
  "期权",
  "B股",
  "场内基金",
  "瑞士GDR",
  "全球债券",
  "国债期货",
  "未知",
}

export enum StockSubType{
  "科创板",
  "创业板",
  "北证A股",
  "沪市指数",
  "深市指数",
  "京市指数",
  "中证指数",
  "商品期货",
  "金融期货",
  "国际期货",
  "沪市主板",
  "深市主板",
  "纳斯达克指数",
  "中国关键期国债",
  "美国关键期国债",
  "全球关键期国债",
  "国债个券",
  "预发行个券",
  "全球关键期预发行国债",
  "未知",
}

export enum PageBondType {
  "上证可转债",
  "深证可转债",
  "上证现券",
  "深证现券",
  "北证债券",
  "上证质押式回购",
  "深证质押式回购",
  "未知",
}

export enum BondType{
  "国债",
  "地方债",
  "企业债",
  "公司债",
  "可转债",
  "可交换债",
  "资产证券化",
  "债权回购",
  "其他债权",
  "未知",
}

export enum StockErrorTradeStatus{
  "停牌",
  "已退市",
  "暂停上市",
  "未上市",
  "未知",
}

export enum StockCurrency{
  "人民币",
  "港元",
  "未知",
}

export function getPageType(){
  let quotedata = window.quotedata
  if(quotedata == undefined) return PageType.未知

  if(quotedata.market == 155 || quotedata.market == 156){
    return PageType.英股
  }
   else if (quotedata.market == 176) {
    return PageType.日本
  } else if (quotedata.market == 177) {
    return PageType.韩国
  } else if (quotedata.market == 178) {
    return PageType.台湾
  } else if (quotedata.market == 186) {
    return PageType.法国
  } else if (quotedata.market == 185) {
    return PageType.德国
  } else if (quotedata.market == 179) {
    return PageType.马来西亚
  } 
  else if (quotedata.market == 105 || quotedata.market == 106 || quotedata.market == 107 || quotedata.market == 153) {
    return PageType.美股
  }
  else if (quotedata.market == 119 || quotedata.market == 133){
    return PageType.外汇
  } else if (quotedata.market == 100 || quotedata.market == 124 || quotedata.market == 125 || quotedata.market == 251) {
    return PageType.全球指数
  } else if (quotedata.market == 0 && (quotedata.type111 == 6 || quotedata.type111 == 13 || quotedata.type111 == 80 || (quotedata.type111 == 81 && quotedata.type181 & 2048))) {
    return PageType.沪深A股
  } else if (quotedata.market == 1 && (quotedata.type111 == 2 || quotedata.type111 == 23)) {
    return PageType.沪深A股
  } else if (quotedata.market == 90) {
    return PageType.板块
  }
  // 沪深京、中证、国证指数
  else if ((quotedata.market == 1 || quotedata.market == 0 || quotedata.market == 2) && (quotedata.type111 == 1 || quotedata.type111 == 5 || quotedata.type111 == 34 || quotedata.type111 == 24)) {
    return PageType.沪深京指数
  } else if (quotedata.market == 13) {
    return PageType.国证指数
  } else if (quotedata.market == 120) {
    return PageType.人民币中间价
  }
  // 债券
  else if (
    (quotedata.market == 1 || quotedata.market == 0) &&
    (quotedata.type182 == 7 || quotedata.type182 == 8 || quotedata.type182 == 9 || quotedata.type182 == 10 || quotedata.type182 == 11 || quotedata.type182 == 12 || quotedata.type182 == 13 || quotedata.type182 == 14 || quotedata.type182 == 15)
  ) {
    return PageType.债券
  } else if (quotedata.market == 47 && (quotedata.code.startsWith("800") || ((quotedata.code.startsWith("881") || quotedata.code.startsWith("880")) && !quotedata.code.endsWith("BI")))) {
    return PageType.choice指数
  } else if (quotedata.market == 116 || quotedata.market == 128) {
    return PageType.港股
  } else if (
    quotedata.market == 113 ||
    quotedata.market == 114 ||
    quotedata.market == 115 ||
    quotedata.market == 142 ||
    quotedata.market == 225 ||
    quotedata.market == 101 ||
    quotedata.market == 102 ||
    quotedata.market == 103 ||
    quotedata.market == 104 ||
    quotedata.market == 108 ||
    quotedata.market == 109 ||
    quotedata.market == 110 ||
    quotedata.market == 111 ||
    quotedata.market == 112 ||
    quotedata.market == 8 ||
    quotedata.market == 220
  ) {
    return PageType.期货
  } else if (quotedata.market == 10 || quotedata.market == 11 || quotedata.market == 12 || quotedata.market == 140 || quotedata.market == 141 || quotedata.market == 151 || quotedata.market == 163 || quotedata.market == 221 || quotedata.market == 226) {
    return PageType.期权
  } else if (quotedata.market == 0 && quotedata.type111 == 7) {
    return PageType.B股
  } else if (quotedata.market == 1 && quotedata.type111 == 3) {
    return PageType.B股
  } else if (quotedata.market == 0 && quotedata.type111 == 10) {
    return PageType.场内基金
  } else if (quotedata.market == 1 && quotedata.type111 == 9) {
    return PageType.场内基金
  } else if (quotedata.market == 252) {
    return PageType.瑞士GDR
  } else if (quotedata.market == 171) {
    return PageType.全球债券
  } else if (quotedata.market == 103 && (quotedata.type111 == 13 || quotedata.type111 == 14 || quotedata.type111 == 15 || quotedata.type111 == 16 || quotedata.type111 == 17)) {
    return PageType.国债期货
  }
  return PageType.未知
}

export function getStockSubType() {
  let quotedata = window.quotedata
  if (quotedata == undefined) return StockSubType.未知

  if (quotedata.market == 0 && quotedata.type111 == 80) {
    return StockSubType.创业板
  } else if (quotedata.market == 1 && quotedata.type111 == 23) {
    return StockSubType.科创板
  } else if (quotedata.market == 1 && quotedata.type111 == 2) {
    return StockSubType.沪市主板
  } else if (quotedata.market == 0 && (quotedata.type111 == 6 || quotedata.type111 == 13)) {
    return StockSubType.深市主板
  } else if (quotedata.market == 0 && quotedata.type111 == 81 && quotedata.type181 & 2048) {
    return StockSubType.北证A股
  } else if (quotedata.market == 1 && quotedata.type111 == 1) {
    return StockSubType.沪市指数
  } else if (quotedata.market == 0 && quotedata.type111 == 5) {
    return StockSubType.深市指数
  } else if (quotedata.market == 0 && quotedata.type111 == 34) {
    return StockSubType.京市指数
  } else if (quotedata.market == 2 && quotedata.type111 == 24) {
    return StockSubType.中证指数
  } else if (quotedata.market == 113 || quotedata.market == 114 || quotedata.market == 115 || quotedata.market == 142 || quotedata.market == 225) {
    return StockSubType.商品期货
  } else if (quotedata.market == 101 || quotedata.market == 102 || quotedata.market == 103 || quotedata.market == 104 || quotedata.market == 108 || quotedata.market == 109 || quotedata.market == 110 || quotedata.market == 111 || quotedata.market == 112) {
    return StockSubType.国际期货
  } else if (quotedata.market == 8 || quotedata.market == 220) {
    return StockSubType.金融期货
  } else if (quotedata.market == 251) {
    return StockSubType.纳斯达克指数
  } else if (quotedata.market == 171 && quotedata.type111 == 0) {
    return StockSubType.国债个券
  } else if (quotedata.market == 171 && quotedata.type111 == 1) {
    return StockSubType.中国关键期国债
  } else if (quotedata.market == 171 && quotedata.type111 == 2) {
    return StockSubType.美国关键期国债
  } else if (quotedata.market == 171 && quotedata.type111 == 3) {
    return StockSubType.全球关键期预发行国债
  } else if (quotedata.market == 171 && quotedata.type111 == 4) {
    return StockSubType.全球关键期国债
  } else if (quotedata.market == 171 && quotedata.type111 == 5) {
    return StockSubType.预发行个券
  }
  return StockSubType.未知
}

export function isTips(market: number, subType: number) {
  if (market == 171 && subType == 1) {
    return true
  } else if (market == 171 && subType == 2) {
    return true
  } else if (market == 171 && subType == 4) {
    return true
  } else {
    return false
  }
}

export function getBondSubType() {
  let quotedata = window.quotedata

  if (quotedata.market == 0) {
    if (quotedata.type182 == 11) {
      return PageBondType.深证可转债
    } else if (quotedata.type182 == 14) {
      return PageBondType.深证质押式回购
    } else if (quotedata.type111 == 35) {
      return PageBondType.北证债券
    } else {
      return PageBondType.深证现券
    }
  } else if (quotedata.market == 1) {
    if (quotedata.type182 == 11) {
      return PageBondType.上证可转债
    } else if (quotedata.type182 == 14) {
      return PageBondType.上证质押式回购
    } else {
      return PageBondType.上证现券
    }
  } else {
    return PageBondType.未知
  }
}

export function getBondDetailType() {
  let quotedata = window.quotedata
  const market = quotedata.market
  const type182 = quotedata.type182

  if (market == 0 || market == 1) {
    if (type182 == 7) {
      return BondType.国债
    } else if (type182 == 8) {
      return BondType.地方债
    } else if (type182 == 9) {
      return BondType.企业债
    } else if (type182 == 10) {
      return BondType.公司债
    } else if (type182 == 11) {
      return BondType.可转债
    } else if (type182 == 12) {
      return BondType.可交换债
    } else if (type182 == 13) {
      return BondType.资产证券化
    } else if (type182 == 14) {
      return BondType.债权回购
    } else if (type182 == 15) {
      return BondType.其他债权
    }
  }
  return BondType.未知
}

export function getStockErrorTradeStatus() {
  let quotedata = window.quotedata
  const tradeStatus = quotedata.trade_status

  if (tradeStatus) {
    if (tradeStatus == 6) {
      return StockErrorTradeStatus.停牌
    } else if (tradeStatus == 7) {
      return StockErrorTradeStatus.已退市
    } else if (tradeStatus == 8) {
      return StockErrorTradeStatus.暂停上市
    } else if (tradeStatus == 9) {
      return StockErrorTradeStatus.未上市
    }
  }
  return StockErrorTradeStatus.未知
}

export function isShortTermBond(data:any){
  if(data?.f762 == 1){
    return true
  }else{
    return false
  }
}
